/** */
export const READ_MANY_LOGS = 'read multiple logs.';
export const READ_ONE_LOG = 'read one log.';

export const ADD_ONE_LOG_TO_STORE = 'add one log to store.';
export const ADD_SEARCH_RESULTS_TO_STORE = 'add log search results to store.';
export const ADD_MANY_LOGS_TO_STORE = 'add multiple logs to store.';
export const LOAD_LOGS_TO_STORE = 'load up logs to store.';
export const REM_ONE_LOG_FROM_STORE = 'remove a log from the store.';

/** */
export const readManyLogs = (payload) => ({
  type: READ_MANY_LOGS,
  payload
});

export const readOneLog = (payload) => ({
  type: READ_ONE_LOG,
  payload
});

export const addManyLogsToStore = (payload) => ({
  type: ADD_MANY_LOGS_TO_STORE,
  payload
});

export const addOneLogToStore = (payload) => ({
  type: ADD_ONE_LOG_TO_STORE,
  payload
});

export const addLogSearchResultsToStore = (payload) => ({
  type: ADD_SEARCH_RESULTS_TO_STORE,
  payload
});

export const loadLogsToStore = (payload) => ({
  type: LOAD_LOGS_TO_STORE,
  payload
});

export const removeOneLogFromStore = (payload) => ({
  type: REM_ONE_LOG_FROM_STORE,
  payload
});
